import React from 'react';

const EventTabSelector = ({ categories, activeTab, onTabChange }) => {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <div className="w-full max-w-[1920px] px-4 sm:px-8 md:px-12 lg:px-16 xl:px-24 py-6">
      <div className="flex flex-wrap gap-3 justify-center md:justify-start">
        {categories.map((category) => (
          <button
            key={category.key}
            onClick={() => onTabChange(category.key)}
            className={`
              px-6 py-3 rounded-lg font-semibold font-['Montserrat'] 
              transition-all duration-300 ease-in-out
              text-base sm:text-lg
              ${activeTab === category.key
                ? 'bg-Color-Brand text-white shadow-lg transform scale-105'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200 hover:shadow-md'
              }
            `}
          >
            {category.title}
          </button>
        ))}
      </div>
    </div>
  );
};

export default EventTabSelector;
